// extracted by mini-css-extract-plugin
export default {"root":"src__modules__common__individual-reports-print-popup__root","actions":"src__modules__common__individual-reports-print-popup__actions"};